import {useSyncExternalStore} from 'react'

const identity = (value) => value

export const create = (initializer) => {
  let state
  const listeners = new Set()

  const setState = (partial, replace = false) => {
    const partialState = typeof partial === 'function' ? partial(state) : partial
    if (partialState == null) return

    if (!replace && typeof partialState === 'object') {
      const keys = Object.keys(partialState)
      if (keys.length === 0) return
      const hasChanges = keys.some(key => !Object.is(state[key], partialState[key]))
      if (!hasChanges) return
    }

    const nextState = replace ? partialState : {...state, ...partialState}

    if (Object.is(nextState, state)) {
      return
    }

    state = nextState
    listeners.forEach(listener => listener())
  }

  const getState = () => state

  const subscribe = (listener) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
  }

  const api = {
    setState,
    getState,
    subscribe,
    destroy: () => listeners.clear(),
  }

  state = initializer(setState, getState, api)

  const useBoundStore = (selector = identity) => {
    return useSyncExternalStore(
      subscribe,
      () => selector(state),
      () => selector(state),
    )
  }

  useBoundStore.setState = setState
  useBoundStore.getState = getState
  useBoundStore.subscribe = subscribe
  useBoundStore.destroy = api.destroy

  return useBoundStore
}

export default {create}
